export default __webpack_public_path__ + "static/media/back_webtoon_03.4d706b5e.png";